var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.layer)?_c('span',_vm._l((_vm.prints),function(p){return _c('PrintButtonBase',{key:p,attrs:{"cta":"","linkHref":_vm.printUrl(p),"linkAlt":"Vytisknout výkres vrstvy","tooltip":_vm.layouts[p].name,"icon":_vm.layouts[p].icon}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }